import { z } from "zod";
import { feedQuerySchema } from "../post/feed-query.js";
import type { Message } from "./message.js";

export const conversationsQuerySchema = feedQuerySchema.extend({
	group_id: z.string(),
});

export type ConversationsQueryPayload = z.infer<typeof conversationsQuerySchema>;

export const unreadCountQuerySchema = z.object({
	group_id: z.string().optional(),
});

export type UnreadCountQueryPayload = z.infer<typeof unreadCountQuerySchema>;

export interface Conversation {
	id: string;
	other_user: {
		id: string;
		first_name: string;
		last_name: string;
		photo_url: string | null;
	};
	last_message?: Message;
	unread_count: number;
	created_at: Date;
	updated_at: Date;
}
